import React, { useState } from 'react';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';

const MonitorPage = () => {
  const [responseStatus, setResponseStatus] = useState('');
  const monitor = async () => {
    try {
      const axios = useAxios();
      const response = await axios.doAxios(MethodEnum.get, 'mon/service_mon');

      if (response?.status === 200) {
        setResponseStatus('OK');
      } else {
        setResponseStatus('ERROR');
      }
    } catch (e) {
      setResponseStatus('Exception');
    }
  };

  monitor();

  return <>Status is : {responseStatus}</>;
};
export default MonitorPage;
